import styled from "styled-components";

// Mesmo padrão visual do modal de Cupom (Configuracoes/Cupom/styles.ts):
// espaçamentos em rem calibrados para o root responsivo do app, inputs
// padrão do Conecta e classes reaproveitadas (inputContainer, agendarExpiracao).
export const ContainerBrinde = styled.div`
  display: contents;

  .containerBrinde {
    width: 100%;
    padding: 3rem 0;

    @media (max-width: 768px) {
      padding: 2rem 0;
    }

    .inputContainer {
      display: flex;
      flex-direction: column;
      gap: 32px;
      width: 100%;

      @media (max-width: 768px) {
        gap: 24px;
      }
    }
  }

  /* Linha 1: foto + nome (mesma disposição no desktop e no mobile) */
  .row1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2rem;
    width: 100%;

    .foto {
      flex-shrink: 0;
    }
    .campo-nome {
      flex: 1 1 auto;
      min-width: 0;
    }
  }

  /* Linha 2: estoque + peso lado a lado (mesma disposição no desktop e no mobile) */
  .row2 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    width: 100%;
  }

  /* Regra: título + opções (rádios) + campo condicional */
  .regra {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;

    .regraTitulo {
      color: ${(props) => props.theme.colors.tertiary};
      width: 100%;
      text-align: left;
    }

    /* Rádios no mesmo padrão do cupom (.tipoDescontoRadios): a regra em
       'label' casa também com o label.input-radio interno do Input, deixando
       bolinha + texto na mesma linha. Coluna porque os textos são longos. */
    .regraRadios {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      label {
        cursor: pointer;
        display: flex;
        flex-direction: row-reverse;
        justify-content: flex-end;
        align-items: center;
        gap: 1rem;
      }
    }

    .flex-valorMin {
      width: 100%;
    }
  }

  /* Expiração: mesmo padrão do agendarExpiracao do cupom */
  .agendarExpiracao {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;

    label {
      display: flex;
      gap: 1rem;
      align-items: center;
      cursor: pointer;
    }

    .expiracao {
      display: block;
      transition: 0.3s ease-in-out;
      pointer-events: none;
      opacity: 0;
      transform: translateY(-10px);
    }

    .ativo {
      pointer-events: inherit;
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
